import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = /*#__PURE__*/_createTextVNode("Yes")

import { ref } from "vue";
import {
    MDBBtn,
    MDBModal,
    MDBModalHeader,
    MDBModalTitle,
    MDBModalBody,
    MDBModalFooter,
} from 'mdb-vue-ui-kit';
export interface ModalOptions {
    title: string;
    content: string;
    verify: boolean;
}

// verify modal refs

export default /*#__PURE__*/_defineComponent({
  setup(__props, { expose }) {

const verifyModal = ref(false);
const verifyModalTitle = ref('Alert');
const verifyModalContent = ref('This is an alert');
const verifyModalVerify = ref(false);

let resolvePromise = (r: unknown) => { return r };
let rejectPromise = (r: unknown) => { return r };

function showModal(opts: ModalOptions) {
    // set modal values
    verifyModalTitle.value =  opts.title;
    verifyModalContent.value = opts.content;
    verifyModalVerify.value = opts.verify;

    // open modal
    verifyModal.value = true;

    // Return promise so the caller can get results
    return new Promise((resolve, reject) => {
        resolvePromise = resolve
        rejectPromise = reject
    })
}

function confirmModal() {
    verifyModal.value = false;
    resolvePromise(true)
}

function cancelModal() {
    verifyModal.value = false;
    resolvePromise(false)
}

expose({ showModal });

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(MDBModal), {
    id: "verifyModal",
    tabindex: "-1",
    labelledby: "verifyModalLabel",
    modelValue: verifyModal.value,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((verifyModal).value = $event))
  }, {
    default: _withCtx(() => [
      _createVNode(_unref(MDBModalHeader), null, {
        default: _withCtx(() => [
          _createVNode(_unref(MDBModalTitle), { id: "verifyModalLabel" }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(verifyModalTitle.value), 1)
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_unref(MDBModalBody), { innerHTML: verifyModalContent.value }, null, 8, ["innerHTML"]),
      _createVNode(_unref(MDBModalFooter), null, {
        default: _withCtx(() => [
          _createVNode(_unref(MDBBtn), {
            color: "danger",
            onClick: cancelModal
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(verifyModalVerify.value ? 'No' : 'Close'), 1)
            ]),
            _: 1
          }),
          (verifyModalVerify.value)
            ? (_openBlock(), _createBlock(_unref(MDBBtn), {
                key: 0,
                color: "success",
                onClick: confirmModal
              }, {
                default: _withCtx(() => [
                  _hoisted_1
                ]),
                _: 1
              }))
            : _createCommentVNode("", true)
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["modelValue"]))
}
}

})